import { useUserInfo } from './useUserInfo';

export const useIsSuperadmin = () => useUserInfo().user.isSuperadmin;
